import cf from './cf';
import i11v from './i11v_20211024';

export default class i11v1a extends i11v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'i11v1a';
    this.d_viewDefs = {
      name: '時間帯'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
